import { StrategyType } from '../constants'
import { getSpot } from '../utils'

export default class GuessData {
  public guesserCost: number;
  public guessersMax: number;
  public guesserAmt: number;
  public strategy: string;
  public spots: number[][];
  private puzzle: number[][][];
  private guessInterval?: number;
  constructor (puzzle: number[][][], saveData: Record<string, unknown> = {}) {
    this.puzzle = puzzle
    this.guesserCost = (saveData.guesserCost as number) || 25
    this.guessersMax = (saveData.guessersMax as number) || 0
    this.guesserAmt = (saveData.guesserAmt as number) || 0
    this.strategy = (saveData.strategy as string) || StrategyType.RANDOM
    this.spots = (saveData.spots as number[][]) || []
    if (this.guesserAmt) {
      this.guessInterval = setInterval(() => this.guess(), 5000)
    }
  }

  addGuesser () {
    this.guesserAmt++
    if (!this.guessInterval) {
      this.guessInterval = setInterval(() => this.guess(), 5000)
    }
  }

  removeGuesser () {
    this.guesserAmt--
    if (this.guesserAmt <= 0) {
      clearInterval(this.guessInterval)
      this.guessInterval = undefined
      this.spots = []
    }
  }

  guess () {
    const spots = this.getSpots()
    const coords = []
    for (const spot of spots.keys()) {
      const [x, y] = getSpot(spot)
      coords.push([x, y])
      const randomGuess = Math.floor(Math.random() * this.puzzle[y][x].length)
      this.puzzle[y][x].splice(0, randomGuess)
      this.puzzle[y][x].splice(1)
    }
    this.spots = coords
  }

  getSpots () {
    const spots = new Set() as Set<number>
    const maxGuesses = Math.max(this.puzzle.filter((row) => row.filter((spot) => spot.length > 1)).length, this.guesserAmt)
    if (this.strategy === StrategyType.RANDOM) {
      while (spots.size < maxGuesses) {
        const spot = Math.floor(Math.random() * 81)
        const [x, y] = getSpot(spot)
        if (this.puzzle[y][x].length > 1) {
          spots.add(spot)
        }
      }
    }
    return spots
  }

  serialize () {
    return {
      gusserCost: this.guesserCost,
      guessersMax: this.guessersMax,
      guesserAmt: this.guesserAmt,
      strategy: this.strategy,
      spots: this.spots
    }
  }
}
